export type CaptionRequest =
  | {
      method: "GET";
      path: "/__waka/source-captions";
      params?: undefined;
      body?: undefined;
    }
  | {
      method: "POST";
      path: "/__waka/transcribe";
      params?: undefined;
      body: { assetId: string; revision: string };
    };
export function isCaptionRequest(v: unknown): v is CaptionRequest {
  if (!v || typeof v !== "object" || Array.isArray(v)) return false;
  const r = v as Record<string, unknown>;
  if (
    Object.keys(r).some(
      (k) => !["method", "path", "params", "body"].includes(k),
    ) ||
    r.params !== undefined
  )
    return false;
  if (r.method === "GET" && r.path === "/__waka/source-captions")
    return r.body === undefined;
  if (
    r.method !== "POST" ||
    r.path !== "/__waka/transcribe" ||
    !r.body ||
    typeof r.body !== "object" ||
    Array.isArray(r.body)
  )
    return false;
  const b = r.body as Record<string, unknown>;
  return (
    Object.keys(b).length === 2 &&
    typeof b.assetId === "string" &&
    b.assetId.length > 0 &&
    b.assetId.length <= 256 &&
    typeof b.revision === "string" &&
    b.revision.length > 0 &&
    b.revision.length <= 64
  );
}
